import React from "react";
import { SpinnerContainer } from "./SpinnerStyled";

export default function ChargingSpinner() {
    return (
        <SpinnerContainer>
            <div className="loader">Loading...</div>
        </SpinnerContainer>
    )
}